module.exports = __webpack_public_path__ + "img/yellow-profile-bg.560793f9.png";